import { NgSwitch } from '@angular/common';
import { ChangeDetectionStrategy, Component, ComponentRef, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { App } from '@df/core/app';
import { TimeoutService } from '@df/ng/timeout.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { BasketNotifiactionItemComponent } from '../../../basket/basket-notification-item.component';
import { NNotification } from '../notification.interfaces';
@Component({
    selector: 'notification-item',
    templateUrl: 'notification-item.html',
    styleUrls: ['notification-item.scss'],
    standalone: true,
    imports: [TranslationModule, BasketNotifiactionItemComponent, NgSwitch],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationItemComponent implements OnInit, OnDestroy {
    @Input()
    data: NNotification.IData;
    componentRef: ComponentRef<NotificationItemComponent>;
    private timeout: number;
    constructor(
        private renderer2: Renderer2,
        private elementRef: ElementRef,
        private timeoutService: TimeoutService,
        private app: App
    ) {}
    ngOnInit() {
        if (this.data.duration) {
            this.timeout = this.timeoutService.setTimeout(() => this.close(), this.data.duration);
        }
    }
    ngOnDestroy() {
        clearTimeout(this.timeout);
    }
    close() {
        this.renderer2.addClass(this.elementRef.nativeElement, '_closed');
        clearTimeout(this.timeout);
        this.timeoutService.setTimeout(() => {
            this.componentRef.destroy();
        }, 1000);
    }
}
